import { SelectionMultimediaReference } from '../internal';
/**
 * @ignore
 */
export const SelectionWithMultimediaMixin = (Base) => class extends Base {
    getMultimedia() {
        return this.get("OBJE" /* Tag.Object */, null, SelectionMultimediaReference);
    }
};
//# sourceMappingURL=SelectionWithMultimediaMixin.js.map